import PropTypes from "prop-types";
import * as React from "react";
import { Button, Dialog } from "../../themeV2";

export default function RemoveDialog({ image, note, onConfirm, onClose }) {
  return (
    <Dialog.Root
      open={Boolean(image)}
      onOpenChange={(open) => !open && onClose()}
    >
      <Dialog.Popup size="sm">
        <Dialog.Title>Remove this image?</Dialog.Title>
        <Dialog.Description>
          It is removed from the shop straight away.
          {note ? ` ${note}` : ""}
        </Dialog.Description>
        <Dialog.Actions>
          <Button variant="text" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="filled" onClick={() => onConfirm(image)}>
            Remove
          </Button>
        </Dialog.Actions>
      </Dialog.Popup>
    </Dialog.Root>
  );
}

RemoveDialog.propTypes = {
  image: PropTypes.object,
  note: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
